import { GALLERY_INTERACTIONS_EXPERIMENT_KEY } from './constants';

export const getGalleryInteractionsBucketedCookie = (): string => {
  return `convert_bucketed_${GALLERY_INTERACTIONS_EXPERIMENT_KEY}`;
};
